// src/components/PrivateRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function PrivateRoute({ children }) {
  const { currentUser, userType } = useAuth();

  if (!currentUser) {
    // Usuário não autenticado: vai para login
    return currentUser ? children : <Navigate to="/login" replace />;
  }

  if (userType === "admin") {
    // Se for admin, redireciona para rota admin
    return <Navigate to="/admin" replace />;
  }

  // Parceiro autenticado: permite acesso
  return children;

}